export default "__VITE_ASSET__COjfwUJW__"